export const formatStringToCompare = <T extends Record<string, string | unknown | null>>(
	a: T | string | undefined | null,
	key: keyof T
): string => {
	if (typeof a === 'string') {
		return a;
	} else if (a && Object.prototype.hasOwnProperty.call(a, key) && typeof a[key] === 'string') {
		return <string>a[key];
	}
	return '';
};

export const compareStrings = (a?: string | null, b?: string | null): number => {
	return compareLocaleStrings(a, b);
};

/**
 * Sorts comparison strings using built-in localeCompare
 * Returns 1 if a > b
 * Returns -1 if a < b
 * Returns 0 if a == b
 */
export function compareLocaleStrings(valueA?: string | null, valueB?: string | null): number {
	valueA = valueA ?? '';
	valueB = valueB ?? '';

	// using the localeCompare sort functionality for the time being to provide potential future i18n support
	return valueA.localeCompare(valueB, undefined, { numeric: true, sensitivity: 'base' });
}

export function compareCaseInsensitiveStrings(valueA?: string | null, valueB?: string | null): number {
	valueA = valueA ?? '';
	valueB = valueB ?? '';
	return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
}

export const compareCells = <T extends { [k: string]: unknown }>(
	a: T | undefined | null,
	b: T | undefined | null,
	defaultValue: T
): boolean => {
	const device1 = a ?? defaultValue;
	const device2 = b ?? defaultValue;

	return Object.keys(defaultValue).every((k) => device1[k] === device2[k]);
};

export function sortedStringArraysAreEqual(arr1: string[], arr2: string[]): boolean {
	if (arr1.length !== arr2.length) {
		return false;
	}

	const sorted1 = [...arr1].sort();
	const sorted2 = [...arr2].sort();

	return sorted1.every((value, index) => value === sorted2[index]);
}
